function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  margin-top: 0.5rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  padding: 0.75rem;\n  border-radius: 0.5rem;\n  border: 1px solid ",
        ";\n  background: ",
        ";\n  cursor: pointer;\n  transition: all 0.2s ease;\n\n  &:hover {\n    border-color: var(--theme-primary, #3b82f6);\n    background: var(--theme-paper-hover, #f9fafb);\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  width: 1rem;\n  height: 1rem;\n  margin: 0;\n  cursor: pointer;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  font-weight: 600;\n  color: var(--theme-text, #1f2937);\n  font-size: 0.875rem;\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.75rem;\n  color: var(--theme-text-secondary, #6b7280);\n  line-height: 1.4;\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
import React from 'react';
import styled from '@emotion/styled';
import { TABLET_VIEW_MODE_OPTIONS } from '@edusense/shared-constants';
import { useTabletViewMode } from '@edusense/shared-hooks';
var Container = styled.div(_templateObject());
var ModeOption = styled.label(_templateObject1(), function(props) {
    return props.isSelected ? 'var(--theme-primary, #3b82f6)' : 'var(--theme-border, #e5e7eb)';
}, function(props) {
    return props.isSelected ? 'var(--theme-primary-light, #eff6ff)' : 'var(--theme-paper, #ffffff)';
});
var RadioInput = styled.input(_templateObject2());
var ModeContent = styled.div(_templateObject3());
var ModeLabel = styled.div(_templateObject4());
var ModeDescription = styled.div(_templateObject5());
/**
 * 태블릿 뷰 모드 선택 컴포넌트
 * 사용자가 태블릿 화면에서의 레이아웃 모드를 선택할 수 있게 함
 */ export var TabletViewModeSelector = function(param) {
    var className = param.className;
    var _useTabletViewMode = useTabletViewMode(), viewMode = _useTabletViewMode.viewMode, changeViewMode = _useTabletViewMode.changeViewMode;
    var handleModeChange = function(mode) {
        changeViewMode(mode);
    };
    // TODO: i18n 메시지 추가 필요
    var getModeText = function(key) {
        var texts = {
            'sidebar_default_mode': '사이드바 우선',
            'sidebar_default_desc': '태블릿에서도 사이드바를 항상 표시합니다. 데스크톱과 동일한 레이아웃입니다.',
            'content_focused_mode': '콘텐츠 중심',
            'content_focused_desc': '메인 콘텐츠 영역을 최대한 넓게 사용합니다. 사이드바는 오버레이로 표시됩니다.',
            'balanced_mode': '자동 조정',
            'balanced_mode_desc': '화면 크기에 따라 자동으로 최적의 레이아웃을 선택합니다.'
        };
        return texts[key] || key;
    };
    return /*#__PURE__*/ React.createElement(Container, {
        className: className
    }, TABLET_VIEW_MODE_OPTIONS.map(function(option) {
        return /*#__PURE__*/ React.createElement(ModeOption, {
            key: option.value,
            isSelected: viewMode === option.value
        }, /*#__PURE__*/ React.createElement(RadioInput, {
            type: "radio",
            name: "tablet-view-mode",
            value: option.value,
            checked: viewMode === option.value,
            onChange: function() {
                return handleModeChange(option.value);
            }
        }), /*#__PURE__*/ React.createElement(ModeContent, null, /*#__PURE__*/ React.createElement(ModeLabel, null, getModeText(option.label)), /*#__PURE__*/ React.createElement(ModeDescription, null, getModeText(option.description))));
    }));
};
export default TabletViewModeSelector;
